import React from "react";
import { Button, Box, CircularProgress } from "@tiny/components";
import PlusCircleOutline from "@tiny/icons/generated/PlusCircleOutline";
import SegmentPanel from "../SegmentPanel/SegmentPanel";
import { useConditionsPanel } from "./ConditionsPanel.hooks";
import ConditionGroup from "../ConditionGroup/ConditionGroup";
import { BaseCondition } from "@tiny/api";
import { useFormContext } from "react-hook-form";

const baseAttributesTypes: NonNullable<BaseCondition["attributeType"]>[] = [
  "PROFILE",
  "ACTIVITY",
  "CAMPAIGN",
  "TRAFFIC_CONTROL",
  "WORKFLOW",
  "CUSTOM_ATTRIBUTES",
  "UTM",
];

function ConditionsPanel() {
  const {
    mdUp,
    addConditionGroup,
    fields,
    deleteGroup,
    editDisabled,
    editDisabledTooltip,
    isSegmentLoading,
  } = useConditionsPanel();

  const { watch } = useFormContext();
  const formValues = watch();

  const addTooltip = editDisabled
    ? editDisabledTooltip
    : "You can add at maximum 10 conditions";

  return (
    <SegmentPanel title="Conditions">
      {isSegmentLoading ? (
        <Box
          width="100%"
          height="300px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        fields.map((field, index) => {
          const groupConditions =
            formValues?.conditions?.[1]?.conditions?.[index]?.conditions ||
            (field as any)?.conditions ||
            [];
          const hasActivityCondition = groupConditions.some(
            (cond: any) => cond?.attributeType === "ACTIVITY"
          );
          const hasClickedCondition = groupConditions.some(
            (cond: any) =>
              cond?.attributeType === "ACTIVITY" &&
              cond?.attributeName === "Clicked"
          );
          const attributesTypes = [
            ...baseAttributesTypes,
            ...(hasActivityCondition
              ? (["SENDER"] as NonNullable<BaseCondition["attributeType"]>[])
              : []),
            ...(hasClickedCondition
              ? (["LINK_URL"] as NonNullable<BaseCondition["attributeType"]>[])
              : []),
          ];

          return (
            <ConditionGroup
              prefixName={`conditions.1.conditions.${index}`}
              key={field.id}
              index={index}
              onEmpty={deleteGroup}
              attributesTypes={attributesTypes}
              maxConditions={10}
            />
          );
        })
      )}
      {!isSegmentLoading && (
        <Box px={mdUp ? 6 : 4} py={mdUp ? 5 : 3}>
          <Button
            variant="text"
            noPadding
            startIcon={<PlusCircleOutline />}
            onClick={addConditionGroup}
            disabled={fields.length >= 10 || editDisabled}
            disabledTooltip={addTooltip}
          >
            {fields.length > 0
              ? "Add another set of conditions"
              : "Add condition"}
          </Button>
        </Box>
      )}
    </SegmentPanel>
  );
}

export default ConditionsPanel;
